import { graphql, useStaticQuery } from 'gatsby';

import { useMemo } from 'react';

export default function useAllPolicies() {
    const queryResult = useStaticQuery<{
        [key: string]: { nodes: any[] };
    }>(graphql`
        query AllPolicies {
            allPolicies: allProductsJson(
                filter: { category: { regex: "/Policies/" } }
            ) {
                nodes {
                    code
                    title {
                        en_CA
                        en_US
                        fr_CA
                    }
                    attributes {
                        content {
                            values {
                                en_CA
                                en_US
                                fr_CA
                            }
                        }
                    }
                }
            }
        }
    `);

    return useMemo(() => {
        const { allPolicies } = queryResult;
        return { allPolicies } as Queries.AllPoliciesQuery;
    }, [queryResult]);
}
